import type { CSSProperties } from "react";

/**
 * Izgled kartica na strani porudžbine: okvir, zaglavlje, naslov, napomena i lista redova sa ugnežđenim redovima
 * (otpremnica pod nalogom, držanje pod LOT-om). Dele ih kartice otpreme i rezervisane robe, da strana ostane jedna celina.
 */
export const card: CSSProperties = {
  background: "var(--surface)",
  border: "1px solid var(--border)",
  borderRadius: "var(--r-md)",
  padding: 18,
  display: "flex",
  flexDirection: "column",
  gap: 8,
};
export const cardHead: CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: 4,
};
export const cardTitle: CSSProperties = { margin: 0, fontSize: 14, color: "var(--ink)" };
export const hint: CSSProperties = { margin: 0, fontSize: 12, color: "var(--ink-3)" };
export const item: CSSProperties = { display: "flex", flexDirection: "column", gap: 6 };
export const row: CSSProperties = { display: "flex", flexWrap: "wrap", gap: "2px 10px", alignItems: "baseline", fontSize: 13 };
export const nested: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: 3,
  marginLeft: 4,
  paddingLeft: 10,
  borderLeft: "2px solid var(--border)",
};
export const muted: CSSProperties = { color: "var(--ink-3)", fontSize: 12 };
export const mono: CSSProperties = { fontFamily: "var(--mono)", color: "var(--ink)" };
